import { RootState } from "store/store";
import { connect } from "react-redux";
import { compose } from "redux";
import {
    getEnrollCache,
    getEnrollId,
} from "store/environments/tenants/enroll-tenant/enroll-tenant-selectors";
import { fetchEnrollCache } from "store/environments/tenants/enroll-tenant/enroll-tenant-thunks";
import SuccessMessage from "./SuccessMessage";
import {
    getActiveEnvironmentId,
    getActiveEnvironmentMoniker,
} from "store/environments/environment-selectors";
import withLoader from "hocs/withLoader/withLoader";

const mapStateToProps = (state: RootState) => ({
    enrollCache: getEnrollCache(state),
    enrollId: getEnrollId(state),
    environmentId: getActiveEnvironmentId(state),
    environmentMoniker: getActiveEnvironmentMoniker(state),
});

const SuccessMessageContainer = compose(
    connect(mapStateToProps, { fetchEnrollCache }),
    withLoader
)(SuccessMessage);

export default SuccessMessageContainer;
